import { createContext } from 'react'
import Api, { IApi } from '@api'
import { makeAutoObservable } from 'mobx'
import { UserStore } from './user.stores'
import { UiStore } from './ui.stores'
import { AuthStore } from './auth.stores'
import { BillingStore } from './billing.stores'
import { CompanyStore } from './company.stores'
import { DashboardStore } from './dashboard.stores'
import { EmailStore } from './email.stores'
import { InvoiceStore } from './invoice.stores'
import { ClientStore } from './client.stores'
import { KvKStore } from './kvk.stores'
import { SharedStore } from './shared.stores'
import { QuotationStore } from './quotation.stores'
import { PoliciesStore } from './policies.stores'
import { PaymentStore } from './payment.stores'

export class Store {
  [key: string]: any
  api: IApi
  auth: AuthStore
  billing: BillingStore
  user: UserStore
  ui: UiStore
  dashboard: DashboardStore
  email: EmailStore
  kvk: KvKStore
  company: CompanyStore
  invoice: InvoiceStore
  policies: PoliciesStore
  quotation: QuotationStore
  client: ClientStore
  shared: SharedStore
  payment: PaymentStore

  constructor() {
    makeAutoObservable(this)
    this.api = Api()
    this.auth = new AuthStore(this)
    this.billing = new BillingStore(this)
    this.dashboard = new DashboardStore(this)
    this.email = new EmailStore(this)
    this.user = new UserStore(this)
    this.company = new CompanyStore(this)
    this.kvk = new KvKStore(this)
    this.quotation = new QuotationStore(this)
    this.policies = new PoliciesStore(this)
    this.ui = new UiStore(this)
    this.shared = new SharedStore(this)
    this.client = new ClientStore(this)
    this.invoice = new InvoiceStore(this)
    this.payment = new PaymentStore(this)
  }
}

// Create store lazily to avoid circular dependency issues during module loading
let defaultStore: Store | null = null
export const getDefaultStore = () => {
  if (!defaultStore) {
    defaultStore = new Store()
  }
  return defaultStore
}

// Initialize context with a proxy that creates the store on first access
export const StoreContext = createContext<Store>(
  new Proxy({} as Store, {
    get: (target, prop) => {
      const store = getDefaultStore()
      return store[prop as keyof Store]
    },
  })
)
